import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, Type } from '@angular/core';
import { MapItemComponent, MapItem } from '@ui/shared/util-map';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-sidebar-items',
    templateUrl: './map-sidebar-items.component.html',
    styleUrls: ['./map-sidebar-items.component.scss'],
    standalone: false,
})
export class MapSidebarItemsComponent<MapItemType extends MapItem> {
    @Input({ required: true })
    public mapItems!: Array<MapItemType>;

    @Input()
    public displayAsList?: boolean;

    @Input()
    public gridContentComponentType!: Type<MapItemComponent<MapItemType>>;

    @Input()
    public listCustomContentComponentType?: Type<MapItemComponent<MapItemType>> | undefined;

    @Input()
    public selectedMapItem: MapItemType | undefined;

    @Output()
    public readonly mapItemClicked = new EventEmitter<MapItemType>();

    public onMapItemClicked(mapItem: MapItemType): void {
        this.mapItemClicked.emit(mapItem);
    }
}
